import { render, staticRenderFns } from "./LoginOrRedirect.vue?vue&type=template&id=f5d8edf2&scoped=true"
import script from "./LoginOrRedirect.vue?vue&type=script&lang=js"
export * from "./LoginOrRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d8edf2",
  null
  
)

export default component.exports